module.exports = __webpack_public_path__ + "img/premium_03.b9576493.jpg";